import React from "react";
import * as componentStyle from "./caseStudyTestimonialCard.module.scss";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { GatsbyImageInterface } from "../../../../interface/image.interface";



interface ImageInterface {
  altText: string | null;
  localFile: GatsbyImageInterface | null;
}
interface FeaturedImageInterface {
  node: ImageInterface | null;
}
interface TestimonialsInterafce {
  professions: string | null;
}
interface CaseStudyTestimonialCardInterface {
  title: string | null;
  id: string | null;
  date: string | null;
  content: string | null;
  featuredImage: FeaturedImageInterface | null;
  testimonials: TestimonialsInterafce | null;
}
export interface CaseStudyTestimonialCardProps {
  node: CaseStudyTestimonialCardInterface | null;
}
export default function CaseStudyTestimonialCard({ data }: { data: CaseStudyTestimonialCardProps | null }) {
  
  
  return (
    <div className={componentStyle.caseStudyTestimonialCard}>
      {data?.node?.featuredImage?.node?.localFile && (
        <div className={componentStyle.caseStudyTestimonialCard__imageBox}>
          <GatsbyImage
            image={getImage(data?.node?.featuredImage?.node?.localFile as any) as IGatsbyImageData}
            alt={data?.node?.featuredImage?.node?.altText || 'N/A'}
          />
        </div>
      )}
      <div className={componentStyle.caseStudyTestimonialCard__reviewDetails}>
        {data?.node?.content && <div className={componentStyle.caseStudyTestimonialCard__review} dangerouslySetInnerHTML={{ __html: data.node.content }}></div>}
        <div className={componentStyle.caseStudyTestimonialCard__owner}>
          {data?.node?.title && <div className={componentStyle.caseStudyTestimonialCard__name}>{data?.node?.title}</div>}
          {data?.node?.testimonials?.professions && <div className={componentStyle.caseStudyTestimonialCard__designation}>{data?.node?.testimonials?.professions}</div>}
        </div>
      </div>
    </div>
  );
}
